import React, { useRef, useEffect, useState } from 'react';
import './CustomDropdown.scss';

interface CustomDropdownProps {
  onClick: (option: string) => void;
  options: string[];
  isOpen: boolean;
  onClose: () => void;
  customClassName?: string;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({ onClick, options, isOpen, onClose, customClassName }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleSelect = (option: string) => {
    setSelectedOption(option);
    onClick(option);
    onClose();
  };

  return (
    <div className='custom-dropdown-dropdown' ref={dropdownRef}>
      {isOpen && (
        <div className={`custom-dropdown-dropdown-menu ${customClassName}`}>
          {options.map((option, index) => (
            <div
              key={index}
              className={`custom-dropdown-dropdown-item ${selectedOption === option ? 'selected' : ''}`}
              onClick={() => handleSelect(option)}
            >
              <span className='flex justify-between items-center ml-auto'>
                {option}
                {selectedOption === option && (
                  <svg
                    className='check_mark'
                    xmlns='http://www.w3.org/2000/svg'
                    width='15'
                    height='11'
                    viewBox='0 0 15 11'
                    fill='none'
                  >
                    <path d='M14.1666 0.833374L4.99992 10L0.833252 5.83337' />
                  </svg>
                )}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
